"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxWrapFieldInfo = exports.BoxWrapInfo = exports.BoxWrap = void 0;
var list_1 = require("@devexpress/utils/lib/utils/list");
var BoxWrap = (function () {
    function BoxWrap(box, info) {
        this.box = box;
        this.info = info;
    }
    BoxWrap.prototype.splitByPosition = function (measurer, pos) {
        return new BoxWrap(this.box.splitBoxByPosition(measurer, pos), this.info);
    };
    return BoxWrap;
}());
exports.BoxWrap = BoxWrap;
var BoxWrapInfo = (function () {
    function BoxWrapInfo(paragraphIndex, sectionIndex, tablePosition, fieldsInfo) {
        this.pageIndexFromWhichTableWasMoved = null;
        this.paragraphIndex = paragraphIndex;
        this.sectionIndex = sectionIndex;
        this.tablePosition = tablePosition;
        this.fieldsInfo = fieldsInfo;
    }
    BoxWrapInfo.prototype.equalsTablePositions = function (tablePos) {
        if (!this.tablePosition)
            return !tablePos;
        if (!tablePos || this.tablePosition.length != tablePos.length)
            return false;
        return list_1.ListUtils.allOf2(this.tablePosition, tablePos, function (a, b) { return a.equals(b); });
    };
    BoxWrapInfo.prototype.getTableNestedLevel = function () {
        return (this.tablePosition ? this.tablePosition.length : 0) - 1;
    };
    return BoxWrapInfo;
}());
exports.BoxWrapInfo = BoxWrapInfo;
var BoxWrapFieldInfo = (function () {
    function BoxWrapFieldInfo(field, isInCodePart) {
        this.field = field;
        this.isInCodePart = isInCodePart;
    }
    BoxWrapFieldInfo.make = function (field, pos) {
        return new BoxWrapFieldInfo(field, field.getCodeIntervalWithBorders().contains(pos));
    };
    return BoxWrapFieldInfo;
}());
exports.BoxWrapFieldInfo = BoxWrapFieldInfo;
